<template>
    <div>
        <table style='margin-left:auto; margin-right:auto'>
            <tr>
                <td>
                    <a href='https://chrome.google.com/webstore/detail/hgpmbjkiigbpcofedhglalcpmgikmeib'>Chrome Addon</a>
                </td>
                <td>
                    <a href='https://fbe-authserver-uaxpuwzs5q-uw.a.run.app/static/ffaddon/fredbot-0.0.2-fx.xpi'>Firefox Addon</a>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>

export default {
    name: 'BrowserPlugins'
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/components/BrowserPlugins.vue